/**
 * 针对于 User 模块的 SourceType 架构的用户输入
 * 在用户 Input 时修改对应的 SourceType
 * @author yongsong.hao
 */
// @ts-nocheck
import { SourceTypeEnum } from '@inv/constants'
import { useDebounceFn, useLatest } from '@inv/hooks'
import { RegisterField, TriggerTypeEnum, ValidContext, ValidateOptions } from '@inv/hooks'
import isFunction from 'lodash/isFunction'
import { ValidateOptionsExtra } from '../typing'

const sourceType = SourceTypeEnum.UserInput
const triggerType = TriggerTypeEnum.TRIGGER_USER_INPUT

interface IUserInputHookOtp {
  wait?: number
  formatter?: <T>(value: T) => T
}

/**
 * 针对于 EleCode Field 的用户输入封装
 * @param field
 * @param wait
 * @returns
 */
export function useUserInput<T>(field: RegisterField<T>, opt?: IUserInputHookOtp) {
  const { wait = 0 } = opt ?? {}
  const fieldLatest = useLatest(field)
  const validateDebounce = useDebounceFn(fieldLatest.current?.validate, { wait })

  return async function (
    value: T,
    {
      immediate = false,
      transformMeta = _meta_ => _meta_,
      extra = {},
      ...options
    }: Partial<{ immediate: boolean } & ValidateOptions> = {}
  ) {
    // 防止sourceType UI 的闪烁
    fieldLatest.current.setMeta(prev => ({ ...prev, sourceType }))

    value = isFunction(opt?.formatter) ? opt?.formatter<T>(value) : value

    fieldLatest.current.setValue(value)

    /**
     * Important!!!
     * Important!!!
     * Important!!!
     * 不能移除，因为 React hooks 是异步的，如果不 await 在 validate 中获取的 source 将会是上一个的
     */
    await Promise.resolve()
    return (
      wait === 0 || !!immediate ? fieldLatest.current.validate : validateDebounce.run
    )<ValidateOptionsExtra>({
      value,
      optimization: true,
      loading: true,
      ...options,
      transformMeta: _meta => {
        return { ...transformMeta(_meta), sourceType }
      },
      extra: { sourceType, triggerType, ...extra }
    })
  }
}

export function onComputedContext(context: ValidContext<any>): { sourceType: SourceTypeEnum } {
  return {
    sourceType:
      context?.options?.extra?.sourceType ??
      context?.getMeta()?.sourceType ??
      SourceTypeEnum.Unknown
  }
}
